import React, { useContext, useEffect, useState, useMemo } from 'react';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useSelector } from "react-redux";
import BallotOutlinedIcon from "@mui/icons-material/BallotOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { Box, Tabs, Tab, Badge } from "@mui/material";
import TabPanel from "../TabPanel";
import DataValidation from './DataValidation';
import { useTranslation } from 'react-i18next';
import datatypes from '../../constants/datatypes';
import FilteringOptions from './Forms/FilteringOptions';
import PluginProperties from './Forms/PluginProperties';
import Description from './Description';
import { lgDocPath } from '../../constants/languageDocPaths';
import OutboundRecordProperties from './OutboundRecordProperties/OutboundRecordProperties';
import OutboundFieldPropertyForm from './Forms/OutboundFieldPropertyForm';
import OutboundActionProperties from './OutboundActionProperties'
import ConditionalIfFields from './Forms/ConditionalIfFields';
import VariableProperties from './Forms/VariableProperties';
import OutboundVariableCollectionProperties from './OutboundVaribleCollectionProperties/OutboundVariableCollectionProperties';
import CustomDBProperties from './Forms/CustomDBProperties';
import CustomDBDescription from './Forms/CustomDBDescription';
import { OutboundSequenceProperties, OutboundSequencePropertyForm } from './Forms/OutboundSquenceProperties/OutboundSequencePropertyForm';
import OutboundVariableCollectionDescription from './OutboundVaribleCollectionProperties/OutboundVariableCollectionDescription';
import OutboundFieldGroupProperties from './Forms/OutboundFieldGroupProperties';
import OutboundFieldGroupDataValidation from './Forms/OutboundFieldGroupDataValidation';
import ElementProperties from './Forms/ElementProperties';
import VariableDescription from './VariableDescription';
import CommentProperties from './CommentProperties';
import ConditionalElse from './Forms/ConditionalElse';
import OutboundElementPropertyForm from './Forms/OutboundElementPropertyForm';
import TrackingReportProperties from './Forms/TrackingReportProperties';
import GraphQLProperties from './Forms/GraphQLProperties';

function OutboundPropertiesContainer() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const queryParams = useSelector(state => state.queryParams);
  const { currentScreen } = useSelector((state) => state.treeData);
  const { rightTree, leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const [currTab, setCurrTab] = useState(0);
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const { ICON_DISPLAY, TYPE, GRAPHQL_RECORD } = selectedNode;
  const templateHeader = rightTree.tree.templateHeader;
  const timestamp = Date.now();
  const handleTabChange = (event, newValue) => {
    setCurrTab(newValue);
  };

  useEffect(() => {
    setCurrTab(0);
  }, [selectedNode?.key])

  // const docPath = `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/screens/${parentScreen}/index.html`;
  const docPath = useMemo(
    () =>
      `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || "en"
      }/Workbench/screens/${parentScreen}/index.html?timestamp=${timestamp}`,
    [leftTree?.tree?.body?.selectedNode?.key, queryParams, parentScreen]
  );

  return (
    <>
      {(!ICON_DISPLAY) &&
        parentScreen === 'outbound' && (
          <iframe
            className="docFrame"
            src={docPath}
            style={{ height: "calc(100% - 3px)", border: "unset" }}></iframe>
        )}
      {(
        (["RECORD_LOOP","RECORD","JSON_TOP_RECORD","QUERY","RECORD_TOP"].includes(ICON_DISPLAY) && TYPE !== 'QUERY' && templateHeader?.FILETYPE !== "GraphQL") ||
        (["ELEMENT", "REPEATING_ELEMENT"].includes(ICON_DISPLAY) && currentTab !== "body") ||
        (["ELEMENT", "REPEATING_ELEMENT"].includes(ICON_DISPLAY) && currentTab === "body" && selectedNode?.XML_RECORD === "TRUE") 
      ) && (
        <Box height={"100%"}>
          {ICON_DISPLAY && ICON_DISPLAY !== "COMMENT" && (
            <>
              <Box className="divider-bottom">
                <Tabs value={currTab} onChange={handleTabChange}>
                  {
                  // templateHeader.FILETYPE !== datatypes[12] &&
                    (TYPE !== 'QUERY') && (
                      <Tab
                        label={
                          <div className="flex align-center">
                            <BallotOutlinedIcon
                              size="small"
                              className="margin-right-4"
                            />
                            {templateHeader?.FILETYPE === 'DATABASE' ? t("LBL_DB_REC_PROPS") : t("LBL_DISPLAY_REC_PROP")}
                          </div>
                        }
                      />
                    )}
                  {(
                    ["RECORD", "RECORD_LOOP", "QUERY", "ELEMENT", "REPEATING_ELEMENT"].includes(ICON_DISPLAY) && 
                    templateHeader?.FILETYPE !=='JSON' && 
                    TYPE !== 'QUERY'
                  ) && (
                      <Tab
                        label={
                          <div className="flex align-center">
                            <FactCheckOutlinedIcon
                              size="small"
                              className="margin-right-4"
                            />
                            {t("FILTER_OPTS")}
                          </div>
                        }
                      />
                    )}
                  {(
                    ["RECORD", "RECORD_LOOP", "QUERY"].includes(ICON_DISPLAY) && 
                    !['JSON','DATABASE'].includes(templateHeader.FILETYPE)
                  ) && (
                      <Tab
                        label={
                          <div className="flex align-center">
                            <FactCheckOutlinedIcon
                              size="small"
                              className="margin-right-4"
                            />
                            {t("LBL_DATA_VALIDATION")}
                          </div>
                        }
                      />
                    )}
                </Tabs>
              </Box>
              <Box className="height-100-tab overflow-auto">
                {((["RECORD_LOOP","RECORD","JSON_TOP_RECORD","QUERY","RECORD_TOP", "ELEMENT", "REPEATING_ELEMENT"].includes(ICON_DISPLAY)) && TYPE !== 'QUERY' && currentScreen === 'outbound') && (
                    <TabPanel
                      style={{ minWidth: "150px" }}
                      className="padding-12"
                      value={currTab}
                      index={0}>
                      <OutboundRecordProperties />
                    </TabPanel>
                  )}
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={1}>
                  <FilteringOptions />
                </TabPanel>
                <TabPanel
                  style={{ minWidth: "150px" }}
                  value={currTab}
                  index={2}>
                  <DataValidation
                    isVisible={ICON_DISPLAY !== "COMMENT" && currTab === 2}
                  />
                </TabPanel>
              </Box>
            </>
          )}
          {/* {ICON_DISPLAY !== 'RECORD_LOOP' && <iframe
                className="docFrame"
                src={docPath}
                style={{ height: "99%", border: "unset" }}
            ></iframe>} */}
        </Box>
      )}
      {ICON_DISPLAY === "PLUGIN" && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_PLUGIN_PROP")}
                  </div>
                }
              />
              <Tab
                label={
                  <div className="flex align-center">
                    <FactCheckOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    <Badge
                      color="primary"
                      variant="dot"
                      invisible={!selectedNode?.DESCRIPTION?.trim()}>
                      <span>{t("DESCRIPTION")}</span>
                    </Badge>
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <PluginProperties />
            </TabPanel>
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
              <Description />
            </TabPanel>
          </Box>
        </Box>
      )}
      {ICON_DISPLAY === "ACTION_ITEM" && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <span className="ACTION_ITEM margin-right-4"></span>
                    {t("LBL_ACT_PROP")}
                  </div>
                }></Tab>
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} className="padding-12" value={currTab} index={0}>
              <OutboundActionProperties />
            </TabPanel>
          </Box>
        </Box>
      )}
      {ICON_DISPLAY === "VARIABLE_COLLECTION" && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <FactCheckOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_VAR_COLL_PROP")}
                  </div>
                }></Tab>
              <Tab
                label={
                  <div className="flex align-center">
                    <FactCheckOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    <Badge
                      color="primary"
                      variant="dot"
                      invisible={!selectedNode?.DESCRIPTION?.trim()}>
                      <span>{t("DESCRIPTION")}</span>
                    </Badge>
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel
              style={{ minWidth: "150px" }}
              className="padding-12"
              value={currTab}
              index={0}>
              <OutboundVariableCollectionProperties />
            </TabPanel>
            <TabPanel
              style={{ minWidth: "150px" }}
              className="padding-12"
              value={currTab}
              index={1}>
              <OutboundVariableCollectionDescription />
            </TabPanel>
          </Box>
        </Box>
      )}
      {["FIELD", "DATABASE_FIELD", "FIELD_LOOP"].includes(ICON_DISPLAY) && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_FLD_PROP")}
                  </div>
                }
              />
              {templateHeader.FILETYPE !== "DATABASE" && (
                <Tab
                  label={
                    <div className="flex align-center">
                      <FactCheckOutlinedIcon
                        size="small"
                        className="margin-right-4"
                      />
                      {t("LBL_DATA_VALIDATION")}
                    </div>
                  }
                />
              )}
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <OutboundFieldPropertyForm />
            </TabPanel>
            {templateHeader.FILETYPE !== "DATABASE" && (
              <TabPanel
                style={{ minWidth: "150px" }}
                value={currTab}
                index={1}>
                <DataValidation
                  isVisible={ICON_DISPLAY !== "COMMENT" && currTab === 2}
                />
              </TabPanel>
            )}
          </Box>
        </Box>
      )}
      {ICON_DISPLAY === "CONDITION_IF" && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_COND_FLD_LIST_PROP")}
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <ConditionalIfFields />
            </TabPanel>
          </Box>
        </Box>
      )}
      {ICON_DISPLAY === "CONDITION_ELSE" && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_ITEMLIST_ELSE_BLOCK_PROP")}
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <ConditionalElse />
            </TabPanel>
          </Box>
        </Box>
      )}
      {ICON_DISPLAY === "VARIABLE" && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_VAR_PROP")}
                  </div>
                }
              />
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    <Badge
                      color="primary"
                      variant="dot"
                      invisible={!selectedNode?.DESCRIPTION?.trim()}>
                      <span>{t("DESCRIPTION")}</span>
                    </Badge>
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <VariableProperties />
            </TabPanel>
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
              <VariableDescription />
            </TabPanel>
          </Box>
        </Box>
      )}
      {
        ICON_DISPLAY === "TRACKING_REPORT_ITEM" && (
          <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_TRACKING_REPORT_PROP")}
                  </div>
                }
              />
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    <Badge
                      color="primary"
                      variant="dot"
                      invisible={!selectedNode?.DESCRIPTION?.trim()}>
                      <span>{t("DESCRIPTION")}</span>
                    </Badge>
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <TrackingReportProperties />
            </TabPanel>
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
              <VariableDescription />
            </TabPanel>
          </Box>
        </Box>
        )
      }
      {ICON_DISPLAY === "ATTRIBUTE" && (
        <Box height={"100%"}>
        <Box className="divider-bottom">
          <Tabs value={currTab} onChange={handleTabChange}>
            <Tab
              label={
                <div className="flex align-center">
                  <BallotOutlinedIcon
                    size="small"
                    className="margin-right-4"
                  />
                  {t('LBL_ATTRIBUTES')}
                </div>
              }
            />
          </Tabs>
        </Box>
        <Box className="height-100-tab overflow-auto">
          <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
            <OutboundFieldPropertyForm XMLAttribute/>
          </TabPanel>
        </Box>
      </Box>
      )}
      {(
        (ICON_DISPLAY === "ELEMENT" || ICON_DISPLAY === "REPEATING_ELEMENT") &&
        currentTab === "body"
      ) && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {ICON_DISPLAY === 'ELEMENT' || ICON_DISPLAY === "REPEATING_ELEMENT" ? t("LBL_ELEM_PROPERTIES") : t('LBL_ATTRIBUTES')}
                  </div>
                }
              />
              <Tab
                label={
                  <div className="flex align-center">
                    <FactCheckOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("FILTER_OPTS")}
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              {/* <ElementProperties /> */}
              <OutboundElementPropertyForm />
            </TabPanel>
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
              <FilteringOptions />
            </TabPanel>
          </Box>
        </Box>
      )}
      {/* {(ICON_DISPLAY === "ELEMENT" || ICON_DISPLAY === "REPEATING_ELEMENT" || ICON_DISPLAY === 'ATTRIBUTE') && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {ICON_DISPLAY === 'ELEMENT' ? t("LBL_ELEM_PROPERTIES") : t('LBL_ATTRIBUTES')}
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <ElementProperties />
            </TabPanel>
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
              <FilteringOptions />
            </TabPanel>
          </Box>
        </Box>
      )} */}
      {(ICON_DISPLAY === "QUERY" && TYPE === 'QUERY') && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_CUST_DB_FLD_PROP")}
                  </div>
                }
              />
              <Tab
                label={
                  <div className="flex align-center">
                    <FactCheckOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    <Badge
                      color="primary"
                      variant="dot"
                      invisible={!selectedNode?.DESCRIPTION?.trim()}>
                      <span>{t("DESCRIPTION")}</span>
                    </Badge>
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <CustomDBProperties />
            </TabPanel>
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
              <CustomDBDescription />
            </TabPanel>
          </Box>
        </Box>
      )}
      {ICON_DISPLAY === "SEQUENCE" && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_SEQ_PROP")}
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <OutboundSequencePropertyForm />
            </TabPanel>
          </Box>
        </Box>
      )}
        {["FIELD_GROUP","REPEATING_FIELD_GROUP"].includes(ICON_DISPLAY) && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_FLD_GRP_PROP")}
                  </div>
                }></Tab>
                 <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_DATA_VALIDATION")}
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel
              style={{ minWidth: "150px" }}
              className="padding-12"
              value={currTab}
              index={0}>
              <OutboundFieldGroupProperties />
            </TabPanel>
            <TabPanel
              style={{ minWidth: "150px" }}
              className="padding-12"
              value={currTab}
              index={1}>
              <OutboundFieldGroupDataValidation isVisible={true} />
            </TabPanel>
          </Box>
        </Box>
      )}
       {ICON_DISPLAY === "COMMENT" && (
        <>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_COMMENT_PROP")}
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <CommentProperties />
            </TabPanel>
          </Box>
        </>
      )}
      {ICON_DISPLAY === "RECORD" && GRAPHQL_RECORD === "TRUE" && templateHeader?.FILETYPE === "GraphQL" && (
        <Box height={"100%"}>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_GRAPHQL_REC_PROPS")}
                  </div>
                }>
                
              </Tab>
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} className="padding-12" value={currTab} index={0}>
              <GraphQLProperties />
            </TabPanel>
          </Box>
        </Box>
      )}
    </>
  );
}

export default OutboundPropertiesContainer